import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { resolveLocale } from '../utils/resolveLocale';

interface IUseCurrencyFormatterResult {
  formatCurrency: (cents: number) => string;
  formatNumber: (value: number) => string;
}

export function useCurrencyFormatter(): IUseCurrencyFormatterResult {
  const { i18n } = useTranslation();

  return useMemo(() => {
    const { intlLocale, currencyCode } = resolveLocale(i18n.language);

    const currencyFormatter = new Intl.NumberFormat(intlLocale, {
      style: 'currency',
      currency: currencyCode,
      maximumFractionDigits: 2,
    });

    const numberFormatter = new Intl.NumberFormat(intlLocale);

    return {
      formatCurrency: (cents: number) => currencyFormatter.format(cents / 100),
      formatNumber: (value: number) => numberFormatter.format(value),
    };
  }, [i18n.language]);
}
